export default __webpack_public_path__ + "static/media/projects_ic.545f3e79.svg";